import styled from 'styled-components';
import {GameTitleDefaultBox} from './game-title.default.box';

export const GameTitleMrGreenBox = styled(GameTitleDefaultBox)`
    ${({theme}) => theme.font.presets.light}
`;
